export default __webpack_public_path__ + "static/media/empty-search.fda633e6.png";